// Reconcile-admin domain constants. Mirrors `backend/internal/constants/reconcile.go`.
//
// CLAUDE.md "Magic values live in constants/": any value shared with
// the backend (or used in more than one FE place) lives here, not at
// the callsite. If a bound changes on the server, this file is the
// one-line FE patch — no callsite grep needed.
//
// Caveat: TS can't import Go constants, so these are duplicated by
// hand. Keep in step with the matching backend file; the server
// re-clamps regardless, so a drifted FE is a UX bug, not a data bug.

// Mirrors constants.FloorplanUnit{Min,Max}Storeys. Used by the merge
// + patch dialogs to bound the operator's n_storeys input. The server
// clamps if the FE drifts; this just keeps the input HTML attrs honest.
export const FLOORPLAN_UNIT_MIN_STOREYS = 1;
export const FLOORPLAN_UNIT_MAX_STOREYS = 4;
